define([
    'handlebars',
    'modules/common/controls/select2',
    'appcontext'
], (Handlebars, Select2, appContext) => {

    function formatState (state) {
        let text = '{0} #{1} {2}'.format(
            Handlebars.helpers.h_channel_img(state.channel_id), state.id, _.escape(state.descriptive_name)
        );
        if (state.descriptive_name !== state.customer_xid) {
            text += ' ({customer_xid})'.format(state);
        }
        return text;
    }

    return Select2.extend({

        formatSelection (state) {
            return formatState(state);
        },

        formatResult (state) {
            return formatState(state);
        },

        matcher (term, text, option) {
            const pattern = term.toUpperCase();
            const channel = appContext.channels().get(option.channel_id);
            const channelName = channel ? channel.get('name') : null;

            return option.descriptive_name.toUpperCase().indexOf(pattern) >= 0 ||
                `${option.id}`.toUpperCase().indexOf(pattern) >= 0 ||
                `${option.customer_xid}`.toUpperCase().indexOf(pattern) >= 0 ||
                (channelName ? channelName.toUpperCase().indexOf(pattern) >= 0 : false);
        }

    });

});
